import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-answer-area',
  templateUrl: './answer-area.component.html',
  styleUrls: ['./answer-area.component.scss']
})
export class AnswerAreaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
